import React from 'react';
import PropTypes from 'prop-types';

// Stylesheets
import './style.scss';

const propTypes = {
    tableData: PropTypes.object.isRequired,
};

function Table({ tableData }) {
    const { rowList, footerList, errorMessage } = tableData;
    const rowLength = tableData.rowList.length;
    const errorMsg = errorMessage || 'No results found';

    return (
        <div className="TableContainer">
            <table className="Table">
                <thead>
                    <tr className="Table-HeadRow">{tableData.headerList}</tr>
                </thead>

                <tbody>{rowList}</tbody>

                { (footerList && footerList.length > 0) ? (
                    <tfoot>{footerList}</tfoot>
                ) : null }

            </table>

            {rowLength === 0 && <div className="Table-error">{errorMsg}</div>}
        </div>
    );
}

Table.propTypes = propTypes;

export { Table };
export default Table;
